<div cs-chart-loader
     [chartOptions]="data.options"
     chartType="{{data.chartType}}"
     [chartData]="chartData"></div>
